(function() {
    'use strict';

    angular
        .module("showcaseApp")
        .component("styledInput", {
            templateUrl: "app/components/styled-input/styled-input.html",
            controller: styledInputController,
            bindings: {
                labelKey: "@",
                model: "=",
                name: "@",
                minLength: "@",
                maxLength: "@",
                required: "<",
                placeholder: "@",
                form: "<",
                mask: "@",
                isBirthDate: "<",
                type: "@",
                format: "@",
                onChange: "&",
                disabled: "<",
                readonly: "<",
                typeaheadExpression: "&",
                typeaheadUsers: "&",
                minDate: "<",
                maxDate: "<",
                showErrorsOnSubmit: "<",
                prefixAddon: "@",
                prefixIcon: "@",
                showObfuscated: "<",
                checkDigitRequired: "<",
            },
        })
        .directive("inputChange", function () {
            return {
                restrict: "A",
                link: function (scope, elem, attrs) {
                    scope.$watch(attrs["ngModel"], function (v) {
                        if (scope && scope.$ctrl && scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ value: v });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function styledInputController(moment, $timeout, $translate, $scope, $localStorage) {
        var vm = this;

        var allErrors = [
            { key: 'required', translateKey: 'entity.validation.required' },
            { key: 'minlength', translateKey: 'entity.validation.minlength' },
            { key: 'maxlength', translateKey: 'entity.validation.maxlength' },
            { key: 'minValue', translateKey: 'entity.validation.min-value' },
            { key: 'maxValue', translateKey: 'entity.validation.max-value' },
            { key: 'duplicatedValue', translateKey: 'entity.validation.duplicated-value' },
            { key: 'pattern', translateKey: getPatternErrorMessage() },
            { key: 'phoneNumber', translateKey: 'entity.validation.phoneNumber' },
            { key: 'cpf', translateKey: 'global.messages.validate.customerIdentity.invalid' },
            { key: 'cnpj', translateKey: 'global.messages.validate.customerIdentity.invalid' },
            { key: 'cnpjIsUnavailable', translateKey: 'entity.validation.cnpj-unavailable' },
            { key: 'nicknameIsUnavailable', translateKey: 'entity.validation.nickname.unavailable' },
            { key: 'emailAlreadyUsed', translateKey: 'register.messages.validate.email.alreadyUsed' },
            { key: 'notEquals', translateKey: 'register.messages.validate.confirmPassword.not-equals' },
            { key: 'parse', translateKey: 'entity.validation.required' },
            { key: 'mask', translateKey: getPatternErrorMessage() },
            { key: 'maxBirthDate', translateKey: 'global.messages.validate.date.maxBirthDate' },
            { key: 'minDate', translateKey: 'global.messages.validate.date.minDate' },
            { key: 'maxDate', translateKey: 'global.messages.validate.date.maxDate' }
        ];

        var checkDigitErrors = [
            { key: 'required', translateKey: 'entity.validation.checkDigitRequired' }
        ];

        vm.$onInit = function() {
            vm.formatPattern = null;
            vm.type = vm.type || 'text';
            vm.isBirthDate = vm.isBirthDate || false;

            if (vm.type === 'check-digit') {
                vm.checkDigitName = vm.name + 'CheckDigit';
                vm.model = vm.model || {};
            }

            switch (vm.type) {
                case 'email':
                    vm.formatPattern = /^(([^<>()\[\]\.,;:\s@"]+(\.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
                    break;
                case 'uib-typeahead':
                    vm.formatPattern =
                        /^(([^<>()\[\]\.,;:\s@"]+(\.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
                    break;
                case 'date':
                    initDateInput();
                    break;
                case 'dateTime':
                    initDateTimeInput();
                    break;
                case 'price':
                    loadCurrencyConfiguration();
                    break;
            }

            $scope.$watch(function() {
                return vm.form && vm.form[vm.name] && vm.form[vm.name].$error;
            }, function(newValue) {
                vm.errors = allErrors.filter(function(error) {
                    return newValue && newValue[error.key];
                });
            }, true);

            $scope.$watch(function() {
                return vm.form && vm.checkDigitName && vm.form[vm.checkDigitName] && vm.form[vm.checkDigitName].$error;
            }, function(newValue) {
                vm.checkDigitErrors = checkDigitErrors.filter(function(error) {
                    return newValue && newValue[error.key];
                });
            }, true);

            vm.readonly = vm.readonly || false;
        };

        vm.clearDate = function() {
            vm.model = null;
        };

        function loadCurrencyConfiguration() {
            vm.currency = $localStorage.defaultStore.storeInfo.currencyConfiguration;
        }

        function getPatternErrorMessage() {
            switch (vm.type) {
                case 'date':
                    return 'global.messages.validate.date.invalid';
                case 'email':
                    return 'global.messages.validate.email.invalid';
                case 'phone':
                    return 'entity.validation.phoneNumber';
                case 'cpf':
                    return 'global.messages.validate.customerIdentity.invalid';
                case 'cnpj':
                    return 'global.messages.validate.customerIdentity.invalid';
                default:
                    return 'global.messages.validate.invalid';
            }
        }

        function initDateInput() {
            var momentDateFormat = vm.format || $translate.instant('momentDateFormat');
            vm.placeholder = vm.placeholder || $translate.instant('placeholderDateFormat');

            $scope.$watchGroup([
                function () { return vm.model; },
                function () { return vm.minDate; },
                function () { return vm.maxDate; }
            ], function () {
                if (!vm.model) return;

                var date = moment(vm.model, momentDateFormat, true);

                if (vm.minDate) {
                    var min = moment(vm.minDate, momentDateFormat, true);
                    vm.form[vm.name].$setValidity('minDate', date.isSameOrAfter(min, 'day'));
                } else {
                    vm.form[vm.name].$setValidity('minDate', true);
                }

                if (vm.maxDate) {
                    var max = moment(vm.maxDate, momentDateFormat, true);
                    vm.form[vm.name].$setValidity('maxDate', date.isSameOrBefore(max, 'day'));
                } else {
                    vm.form[vm.name].$setValidity('maxDate', true);
                }
            });

            $scope.$watch(function() {
                return vm.model;
            }, function(newValue, oldValue) {
                if (angular.isString(newValue) && newValue.length > 0) {
                    var invalidInputRegex = /[^0-9/]/;
                    if (newValue.match(invalidInputRegex)) {
                        vm.model = oldValue;
                    } else if (newValue.length < 10) {
                        var firstBarIndex = newValue.indexOf('/');
                        var lastBarIndex = newValue.lastIndexOf('/');
                        var dateParts = newValue.split('/');
                        var barCount = dateParts.length - 1;
                        if (firstBarIndex === 1) {
                            vm.model = '0' + newValue;
                        } else if (barCount < 3 && firstBarIndex !== lastBarIndex) {
                            var secondPart = dateParts[1];
                            if (secondPart && secondPart.length < 2) {
                                dateParts[1] = '0' + secondPart;
                                vm.model = dateParts.join('/');
                            } else {
                                vm.model = newValue;
                            }
                        } else if (barCount > 2) {
                            dateParts = dateParts.slice(0, 3);
                            vm.model = dateParts.join('/');
                        }
                    } else {
                        if (vm.form && vm.form[vm.name]) {
                            var date = moment(newValue, momentDateFormat);
                            vm.form[vm.name].$setValidity('pattern', date.isValid());

                            if (vm.isBirthDate) {
                                var maxDate = moment();
                                vm.form[vm.name].$setValidity('maxBirthDate', date.isBefore(maxDate));
                            }

                            if (vm.form[vm.name].$valid && date.isValid()) {
                                vm.model = date.format(momentDateFormat);
                            }
                        }
                    }
                } else {
                    if (vm.form && vm.form[vm.name]) {
                        vm.form[vm.name].$setValidity('pattern', true);
                        if (vm.isBirthDate) {
                            vm.form[vm.name].$setValidity('maxBirthDate', true);
                        }
                    }
                }
            });

            $scope.$on('resetDates', function(event, data) {
                if (vm.type === 'date') {
                    vm.clearDate();
                }
            });
        }

        function initDateTimeInput() {
            var momentDateTimeFormat = vm.format || $translate.instant('momentDateTime24HFormat');
            vm.placeholder = vm.placeholder || $translate.instant('placeholderDateTimeFormat');

            $scope.$watch(function() {
                return vm.model;
            }, function (newValue, oldValue) {
                if (angular.isString(newValue) && newValue.length > 0) {
                    var invalidInputRegex = /[^0-9/ :]/;
                    if (newValue.match(invalidInputRegex)) {
                        vm.model = oldValue;
                    } else if (newValue.length < 15) {
                        var firstBarIndex = newValue.indexOf('/');
                        var lastBarIndex = newValue.lastIndexOf('/');
                        var dateParts = newValue.split('/');
                        var barCount = dateParts.length - 1;
                        if (firstBarIndex === 1) {
                            vm.model = '0' + newValue;
                        } else if (barCount < 3 && firstBarIndex !== lastBarIndex) {
                            var secondPart = dateParts[1];
                            if (secondPart && secondPart.length < 2) {
                                dateParts[1] = '0' + secondPart;
                                vm.model = dateParts.join('/');
                            } else {
                                vm.model = newValue;
                            }
                        } else if (barCount > 2) {
                            dateParts = dateParts.slice(0, 3);
                            vm.model = dateParts.join('/');
                        } else {
                            var lastDatePart = dateParts[2];
                            var yearHourParts = lastDatePart.split(' ');
                            var timePart = yearHourParts[1] || '';
                            if (timePart.length > 0) {
                                var colonIndex = timePart.indexOf(':');
                                if (colonIndex === 1) {
                                    timePart = '0' + timePart;
                                }
                                vm.model = dateParts.slice(0, 2).join('/') + '/' + yearHourParts[0] + ' ' + timePart;
                            } else {
                                vm.model = dateParts.slice(0, 2).join('/') + '/' + yearHourParts[0];
                            }
                        }
                    } else {
                        var dateTime = moment(newValue, momentDateTimeFormat);
                        vm.form[vm.name].$setValidity('pattern', dateTime.isValid());

                        if (vm.form[vm.name].$valid && dateTime.isValid()) {
                            vm.model = dateTime.format(momentDateTimeFormat);
                        }
                    }
                } else {
                    vm.form[vm.name].$setValidity('pattern', true);
                }
            });
        }
    }
})();
